import * as api from '../../services/tax/apiTaxType';
import * as apiCommon from '../../services/apiCommon';
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* fetchListTaxTypeSaga(feathersApp) {
	yield takeLatest('FETCH_LIST_TAX_TYPE', callFetchListTaxType, feathersApp);
}


function* callFetchListTaxType(feathersApp, action) {
	const { silent, filters } = action;
	yield common.showProgressListTable(silent);
	try {
		const dataParams = {
			filters,
			list_type: 'tax_type'
		};
		const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
		yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
	} catch (error) {
		yield common.showErrorListTable(error);
	}
}

export function* saveTaxTypeSaga(feathersApp) {
	yield takeEvery("SAVE_TAX_TYPE", callSaveTaxType, feathersApp);
}
function* callSaveTaxType(feathersApp, action) {
	const { tenant, user } = yield select();
	try {
		yield put({ type: 'SAVE_RECORD_INPROGRESS' });

		const params = { tenant, user, data: action.data };
		const result = yield call(api.saveTaxType, feathersApp, params);
		yield common.doneSaveRecord(result, 'Tax type was saved');
		yield put({
			type: SagasType.SIMPLE_FORM_SET_DATA,
			data: result
		});
		yield callFetchListTaxType(feathersApp, { silent: true });
	} catch (e) {
		yield common.showErrorSaveRecord(e);
	}
}

export function* deleteTaxTypeFromListSaga(feathersApp) {
	yield takeEvery('DELETE_TAX_TYPE_FROM_LIST', callDeleteTaxTypeFromList, feathersApp);
}

function* callDeleteTaxTypeFromList(feathersApp, action) {
	yield deleteTaxType(feathersApp, action);
	yield callFetchListTaxType(feathersApp, { silent: true });
}

function* deleteTaxType(feathersApp, action) {
	yield put({ type: 'DELETE_RECORD_INPROGRESS' });
	try {
		const { id } = action;
		let result = null;
		if (id) {
			const state = yield select();
			const { tenant, user } = state;
			const params = { tenant, user, id };
			result = yield call(api.deleteTaxType, feathersApp, params);
			yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.TAX_TYPE } });
			yield callFetchListTaxType(feathersApp, { silent: true });
		}
		return result;
	} catch (error) {
		yield put({ type: 'DELETE_RECORD_ERROR', error })
	}
}

export function* deleteTaxTypeSaga(feathersApp) {
	yield takeEvery('DELETE_TAX_TYPE', callDeleteTaxType, feathersApp);
}

function* callDeleteTaxType(feathersApp, action) {
	yield deleteTaxType(feathersApp, action);
	yield callFetchListTaxType(feathersApp, { silent: true });
}

export function* fetchTaxTypeForEditSaga(feathersApp) {
	yield takeEvery('FETCH_TAX_TYPE_BY_ID', callFetchTaxTypeForEdit, feathersApp);
}

function* callFetchTaxTypeForEdit(feathersApp, action) {
	const { tenant, user } = yield select();
	const { id } = action;
	const docType = DocType.TAX_TYPE;
	try {
		if (id) {
			yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
			const fetchParams = { tenant, user, id };
			const doc = yield call(api.fetchTaxTypeById, feathersApp, fetchParams);
			yield common.doneDataById(doc);
			yield put({
				type: SagasType.SIMPLE_FORM_SET_DATA,
				data: doc
			});
		}
	} catch (error) {
		yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
	}
}
